<template>
  <div>
    <div class="header">
      <span>手术趋势</span>
      <el-form :inline="true" class="header-right">
        <el-form-item>
          <el-cascader
            size="mini"
            style="width: 150px"
            @change="selectOrg"
            ref="cascader"
            @visible-change="orgChange"
            :props="{ checkStrictly: true, value: 'id', label: 'name', children: 'children' }"
            :options="orgs"
            v-model="orgIndex">
          </el-cascader>
        </el-form-item>
        <el-form-item>
          <el-radio-group v-model="dateRadio" size="mini" @change="dateRadioChange">
            <el-radio-button label="年"></el-radio-button>
            <el-radio-button label="月"></el-radio-button>
            <el-radio-button label="日"></el-radio-button>
          </el-radio-group>
        </el-form-item>
        <el-form-item>
          <el-date-picker
            style="width: 130px"
            v-model="start"
            :type="dateType"
            size="mini"
            placeholder="开始日期"
            @change="dateChange">
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-date-picker
            style="width: 130px"
            v-model="end"
            :type="dateType"
            size="mini"
            placeholder="结束日期"
            @change="dateChange">
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-checkbox v-model="checked" :disabled="disabled" @change="loadData">同期对比</el-checkbox>
        </el-form-item>
      </el-form>
    </div>
    <div class="count-operation-checkbox">
      <el-checkbox v-model="isAll" style="float: left; padding-right: 10px" @change="checkAll">全部</el-checkbox>
      <el-checkbox-group v-model="checkboxGroup" size="mini" @change="checkedOrg">
        <el-checkbox
          v-for="(childrenOrg, i) in childrenOrgs"
          :label="childrenOrg"
          :key="i"
        >{{childrenOrg.name || '未设置科室'}}</el-checkbox>
      </el-checkbox-group>
    </div>
    <div>
      <eber-line ref="operationEcharts" v-if="series.length > 0" :series="series" :xAxis="xAxis" :legend="legend" ></eber-line>
      <div v-if="series.length === 0" style="height: 350px; text-align: center; padding-top: 20px;">暂无数据</div>
    </div>
  </div>
</template>

<script>
  import _ from 'lodash'
  import moment from 'moment'
  import OperationCountService from '@/request/count/operation'
  import EberLine from "./eber-line";
  export default {
    name: "CountOperationTrend",
    components: {EberLine},
    props: {
      orgs: {
        type: Array,
        default() {
          return null
        }
      }
    },
    watch: {
      orgs() {
        this.init();
      },
    },
    data() {
      return{
        start: moment().subtract(6, 'days').startOf('day').valueOf(), // 开始时间
        end: moment().endOf('day').valueOf(), // 结束时间
        dateRadio: '日',
        dateType: 'date',
        dataLine: [],
        oids: [], // 所有id
        orgid: null,
        orgIndex: [], // 默认选中第一个组织
        disabled: false, // 同期对比是否可选
        checked: false, // 同期对比绑定值 默认不勾选
        formatType: null,
        xAxis: [], // echarts  x轴数据
        series: [], // echarts series数据
        legend: [],
        isAll: true, // 是否全选 默认是
        childrenOrgs: [], // 科室列表
        checkboxGroup: [], // 选择的科室列表
        selectOrgs: null
      }
    },
    created() {
      this.init();
    },
    methods: {
      init() {
        if (this.orgs.length > 0 ) {
          this.oids = [this.orgs[0].id];
          this.orgIndex = this.oids
          this.orgid = this.oids
          this.childrenOrgs = this.orgs[0].children || [];
          this.dateChange();
        }
      },
      // 当前
      loadData() {
        const _series = [];
        const _legend = [];
        let type = 'day';
        if (this.dateType !== 'date') {
          type = this.dateType
        }
        OperationCountService.countOrg({
          start: moment(this.start).startOf(type).valueOf(),
          end: moment(this.end).endOf(type).valueOf(),
          oids: this.oids.toString(),
          group: type || 'day'
        }).then( res => {
          _.forEach(res.result || [], val => {
            const seriesData = _.clone(this.dataLine);
            _.forEach(val.count || [], (value, key) => {
              const timeLineIndex = this.xAxis.indexOf(key);
              if (timeLineIndex !== -1) {
                seriesData[timeLineIndex] = value;
              }
            });
            let name = val.name;
            if (this.isAll) {
              name = '当期'
            }
            _legend.push(name);
            _series.push({
              name: name,
              type: 'line',
              data: seriesData, //数据
            });
          });
          if (this.checked && this.isAll) {
            this.lastLoadData(_legend, _series);
          } else {
            this.series = _series;
            this.legend = _legend;
          }
        })
      },
      // 往期
      lastLoadData(_legend, _series) {
        let type = 'day';
        if (this.dateType !== 'date') {
          type = this.dateType
        }
        OperationCountService.countOrg({
          start: moment(this.start).subtract(1, 'year').startOf(type).valueOf(),
          end: moment(this.end).subtract(1, 'year').endOf(type).valueOf(),
          oids: this.oids.toString(),
          group: type || 'day'
        }).then( res => {
          _.forEach(res.result || [], val => {
            const seriesData = _.clone(this.dataLine);
            _.forEach(val.count || [], (value, key) => {
              const _key = moment(key).add(1, 'year').format(this.formatType);
              const timeLineIndex = this.xAxis.indexOf(_key);
              if (timeLineIndex !== -1) {
                seriesData[timeLineIndex] = value;
              }
            });
            _legend.push('往期');
            _series.push({
              name: '往期',
              type: 'line',
              data: seriesData, //数据
            });
          });
          this.series = _series;
          this.legend = _legend;
        })
      },
      // 切换医院
      selectOrg(index) {
        let orgs = _.cloneDeep(this.orgs);
        _.forEach(index, (val, i) => {
          let orgIndex = null;
          if (i === 0) {
            orgIndex = _.findIndex(orgs, {id: val});
            orgs = orgs[orgIndex];
          } else {
            orgIndex = _.findIndex(orgs.children, {id: val});
            orgs = orgs.children[orgIndex];
          }
        });
        this.selectOrgs = orgs
      },
      // 下拉框隐藏 确定组织
      orgChange (hide) {
        if (!hide && this.selectOrgs) {
          const _orgid = this.selectOrgs.id;
          if (this.orgid !== _orgid) {
            this.childrenOrgs = this.selectOrgs.children || [];
            this.oids = this.selectOrgs.childrenIds;
            this.orgid = _orgid
            this.isAll = true;
            this.checkAll()
          }
        } else {
          this.$nextTick(() => {
            const lis = this.$refs.cascader.panel.$el.lastChild.querySelectorAll('li')
            _.forEach(lis, val => {
              if (val.className.indexOf('is-active') !== -1) {
                val.click()
              }
            })
          })
        }
      },
      // 选择全部
      checkAll() {
        if (this.isAll) {
          this.oids = [this.orgid];
          // 清空科室选择
          this.checkboxGroup = [];
          this.disabled = false;
          this.loadData();
        }
      },
      // 选择科室
      checkedOrg(data) {
        if (data.length > 0) {
          this.isAll = false;
          this.disabled = true;
          const _oids = [];
          _.forEach(data, val => {
            _oids.push(val.id);
          });
          this.oids = _oids;
          /*if (data.length > 1) {
            this.disabled = true;
          }*/
          this.loadData();
        } else {
          this.isAll = true;
          this.checkAll()
        }
      },
      dateChange() {
        if (!this.start || !this.end) {
          this.$message({
            message: '开始时间或结束时间不能为空',
            type: 'warning'
          });
          return
        }
        if (this.start > this.end) {
          this.$message({
            message: '开始时间不能大于结束时间',
            type: 'warning'
          });
        }
        const timeLine = [];
        const _dataLine = [];
        let type = 'day';
        this.formatType = 'YYYY-M-D';
        if (this.dateType !== 'date') {
          type = this.dateType
        }
        if (this.dateType === 'year') {
          this.formatType = 'YYYY';
        }
        if (this.dateType === 'month') {
          this.formatType = 'YYYY-M';
        }
        const num = moment(this.end).diff(moment(this.start), type);
        switch(type) {
          case 'day':
            this.disabled = num > 365 && this.isAll
            break;
          case 'month':
            this.disabled = num > 12 && this.isAll
            break;
          case 'year':
            this.disabled = num > 1 && this.isAll
            break;
          default:
            this.disabled = true
        }
        if (this.disabled) {
          this.checked = false;
        }
        for (let i = num; i >= 0; i --) {
          const date = moment(this.end).subtract(i, type).format(this.formatType);
          timeLine.push(date);
          _dataLine.push(0);
        }
        this.xAxis = timeLine;
        this.dataLine = _dataLine;
        this.loadData();
      },
      dateRadioChange(event) {
        switch (event) {
          case '年':
            this.dateType = 'year';
            this.start = moment().subtract(4, 'year').startOf('year').valueOf(); // 开始时间
            this.end =  moment().endOf('year').valueOf(); // 结束时间
            break;
          case '月':
            this.dateType = 'month';
            this.start = moment().subtract(12, 'month').startOf('month').valueOf(); // 开始时间
            this.end =  moment().endOf('month').valueOf(); // 结束时间
            break;
          default:
            this.dateType = 'date';
            this.start = moment().subtract(6, 'days').startOf('day').valueOf(); // 开始时间
            this.end =  moment().endOf('day').valueOf(); // 结束时间
        }
        this.dateChange();
      }
    }
  }
</script>

<style scoped>
  /* 未选中样式 */
  .count-operation-checkbox {
    width: 100%;
    min-height: 30px;
  }
  .count-operation-checkbox >>> .el-checkbox__input {
    display: none;
  }
  .count-operation-checkbox >>> .el-checkbox__label {
    /*padding-left: 0;*/
    padding: 2px 10px;
    margin: 5px 0;
    border-radius: 4px;
    color: #999999;
    background-color:#F9F9F9;
  }
  .count-operation-checkbox >>> .el-checkbox__inner {
       border-radius: 0;
  }
  .count-operation-checkbox >>> .el-checkbox {
    color: #a8a8a8;
    text-align: center;
    margin-right: 0;
  }
  .count-operation-checkbox >>> .el-checkbox+.el-checkbox {
    margin-left: 10px;
  }
  /*选中样式*/
  .count-operation-checkbox >>> .el-checkbox__input.is-checked + .el-checkbox__label {
    background-color: #1890ff;
    color: #fff;
  }
  .count-operation-checkbox >>> .el-checkbox__input.is-checked .el-checkbox__inner {
    background-color: #1890ff;
    border-color: #6c7c92;
  }
  .header {
    height: 50px;
    line-height: 48px;
    color: #000;
    border-bottom: 1px solid #ebeef5;
    font-size: 20px;
    font-weight: 500;
    margin-bottom: 20px;
    position: relative;
  }
  .header-right{
    z-index: 999;
    float: right;
    position: absolute;
    right: 0;
    top: 4px;
  }
</style>
